import * as React from "react";
import { FC } from "react";

import AuthContext from "src/context/AuthContext";
import { AdminPermissions, Permissions } from "./Permissions";

type AuthWrapperType = "hide" | "disable";

interface IProps {
	children?: any;
	permissions: Permissions[];
	type: AuthWrapperType;
}

const AuthorizationWrapper: FC<IProps> = (props) => {
	return (
		<AuthContext.Consumer>
			{({ currentUser }) => {
				if (!currentUser) {
					console.error("User is not logged in");
					return null;
				}
				if (props.type === "hide") {
					return currentUser.permissions!.includes(
						AdminPermissions.GlobalAdmin
					) ||
						currentUser.permissions!.find((p) =>
							props.permissions.includes(p as Permissions)
						) !== undefined
						? React.cloneElement(props.children)
						: null;
				} else if (props.type === "disable") {
					return currentUser.permissions!.includes(
						AdminPermissions.GlobalAdmin
					) ||
						currentUser.permissions!.find((p) =>
							props.permissions.includes(p as Permissions)
						) !== undefined
						? React.cloneElement(props.children)
						: React.cloneElement(props.children, { disabled: true });
				} else {
					return null;
				}
			}}
		</AuthContext.Consumer>
	);
};

export default AuthorizationWrapper;
